<template>
    <div class="global">
        <button class="btn_geo" role="button">
            <span v-if="this.$parent.geoloc == false" @click="activeGeoloc()">{{ $t("message.geolocalisation") }}</span>
            <span v-else @click="disableGeoloc()">{{ $t("message.geolocalisationdisable") }}</span>
        </button>
        <div class="filtre" v-for="(item, key) in this.filtresView" :key="item">
            <span class="item active" v-html="item.name" @click="openFiltre(key)" v-if="this.openFiltres.includes(key)"></span>
            <span class="item" v-else v-html="item.name" @click="openFiltre(key)"></span>
            <span v-if="this.openFiltres.includes(key)">
                <div v-for="(term, id) in item.sub_filters" :key="id">
                    <template v-if="term.type.trim() == 'custom' && term.method.trim() == 'taxonomy' && term.count > 0">
                      <label>
                            <template v-if="Array.isArray(term.include) == true">
                                <input class="multiple" type="checkbox" @click="select(term.include, term.taxonomy)"/> 
                            </template>
                            <input type="checkbox" v-else :value="parseInt(term.include)" v-model="selected[term.taxonomy]" />
                            {{ term.name }} <span class="count">{{ term.count }}</span></label>
                        
                    </template>
                    
                    <template v-if="term.type.trim() == 'taxonomy' && term.taxonomy.trim() !== ''">
                        <template v-if="this.allfiltres[term.taxonomy].terms.length > 0">
                            <template v-for="(subterm) in this.allfiltres[term.taxonomy].terms" :key="subterm">
                                <template v-if="subterm.count > 0 && term.exclude.includes(subterm.term_id) == false">
                                <label>
                                <input type="checkbox" :value="parseInt(subterm.term_id)" v-model="selected[term.taxonomy]" />
                                {{ subterm.name }} <span class="count">{{ subterm.count }}</span></label>
                                </template>
                            </template>
                        </template>
                    </template>

                    <template v-if="term.type.trim() == 'custom' && term.method.trim() == 'meta' && term.count > 0">
                        <template v-if="term.field.length == 1">
                            <label>
                                <input type="checkbox" :value="term.value" v-model="selected[term.field]" />
                                {{ term.name }} <span class="count">{{ term.count }}</span></label>
                        </template>
                        <template v-else>
                            <label>
                            <input class="multiple" type="checkbox" @click="selectmeta(term.field, term.value)"/> 
                            {{ term.name }} <span class="count">{{ term.count }}</span></label>
                        </template>
                    </template>

                    <template v-if="term.type.trim() == 'custom' && term.method.trim() == 'notempty' && term.count > 0">
                        <template v-if="term.field.length == 1">
                            <label>
                                <input type="checkbox" @click="selectnotempty(term.field)" />
                                {{ term.name }} <span class="count">{{ term.count }}</span></label>
                        </template>
                        <template v-else>
                            <label>
                            <input class="multiple" type="checkbox" @click="selectnotempty(term.field)"/> 
                            {{ term.name }} <span class="count">{{ term.count }}</span></label>
                        </template>
                    </template>

                    <template v-if="term.type.trim() == 'custom' && term.method.trim() == 'capacite' && term.capacite.length > 0">
                      <label class="capacity">
                          {{ term.name }}
                          <span class="ui-range">
                            <span class="min">{{ 0 }}</span> <span class="current"></span> <span class="max">{{ Math.max(...term.capacite) }}</span>
                            <input type="range" value="0" :min="0" :max="Math.max(...term.capacite)" @change="selectcapacite(term.field, $event)" />
                          </span>
                      </label>
                    </template>
                    <template v-if="term.type.trim() == 'custom' && term.method.trim() == 'post_type' && term.count > 0">
                      <template v-if="term.include.length == 1">
                            <label>
                                <input type="checkbox" @click="selecttypes(term.include)" />
                                {{ term.name }} <span class="count">{{ term.count }}</span></label>
                        </template>
                        <template v-else>
                            <label>
                            <input class="multiple" type="checkbox" @click="selecttypes(term.include)"/> 
                            {{ term.name }} <span class="count">{{ term.count }}</span></label>
                        </template>
                    </template>
                  </div>
            </span>
        </div>
        <FiltreDates 
          v-if="api.dates == true"
          :selectedFilters="selected"
          :api="api"> 
        </FiltreDates>
    </div> 
</template>
<script> 
import FiltreDates from './Filtres/FiltreDates.vue';
export default {
  name: 'GlobalFiltres',  
  data: function() {
    return { 
        filtresView : null, 
        selected: this.selectedFilters,
        openFiltres: [],
        allfiltres: this.$parent.filtres,
        order: 'alpha'
    }
  },
  components: {
    FiltreDates
  },
  props: ['selectedFilters', 'offres', 'api'], 
  methods : { 
    selectcapacite(field, event) {
        const parent = event.target.parentElement;
        parent.querySelector('.current').innerHTML = event.target.value;

        const currentSelect = this.selected;
        const index = currentSelect.capacites.findIndex(capacite => capacite.field === field);

        if (index === -1) {
            currentSelect.capacites.push({ 'field': field, 'value': event.target.value });
        } else {
            currentSelect.capacites[index].value = event.target.value;
        }

        return false;
    },
    selectmeta(field, value) {
      const currentSelect = this.selected;
      
      for (let i = 0; i < field.length; i++) {
        const existingIndex = currentSelect.metas.findIndex(meta => meta.field === field[i]);

        if (existingIndex === -1) {
          currentSelect.metas.push({ 'field': field[i], 'value': value[i] });
        } else {
          currentSelect.metas.splice(existingIndex, 1);
        }
      }

      return false;
    },
    selectnotempty(field) {
      const currentSelect = this.selected;
      
      for (let i = 0; i < field.length; i++) {
        const existingIndex = currentSelect.notempty.findIndex(meta => meta.field === field[i]);

        if (existingIndex === -1) {
          currentSelect.notempty.push({ 'field': field[i] });
        } else {
          currentSelect.notempty.splice(existingIndex, 1);
        }
      }

      return false;
    },
    selecttypes(field) {
      const currentSelect = this.selected;
      for (let i = 0; i < field.length; i++) {
        const existingIndex = currentSelect.post_type.indexOf(field[i]);
        if (existingIndex === -1) {
          currentSelect.post_type.push(field[i]);
        } else {
          currentSelect.post_type.splice(existingIndex, 1);
        }
      }

      return false;
    },
    select(term_id, key) {
      let currentSelect = this.selected;

      term_id.forEach((term) => {
        const index = currentSelect[key].indexOf(term);

        if (index === -1) {
          currentSelect[key].push(term);
        } else {
          currentSelect[key].splice(index, 1);
        }
      });

      return false;
    },
    openFiltre(type) {
      if(this.openFiltres.includes(type)) {
        this.openFiltres.splice(this.openFiltres.indexOf(type), 1);
      }
      else {
        this.openFiltres.push(type);
      }
    },
    initFilters(filtres) {
      this.filtresView = filtres;

      for (const type in this.allfiltres) {
        this.allfiltres[type].terms = this.reorderFiltres(this.allfiltres[type].terms, 'alpha');
        this.selected[type] = [];
      }

      this.selected['metas'] = [];
      this.selected['capacites'] = [];
      this.selected['notempty'] = [];
      this.selected['post_type'] = [];
    },
    reorderFiltres(terms, type) {
      let reorder = terms;
      if(type == 'alpha') {
        reorder.sort(function (a, b) {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
      }
      if(type == 'count') {
        reorder.sort(function (a, b) {
          if (a.count < b.count) {
            return 1;
          }
          if (a.count > b.count) {
            return -1;
          }
          return 0;
        });
      }
      return reorder;
    },
    updateFiltres(offres) {
        this.resetFilterCounter();

        for (const offre of offres) {
            for (const filtreView of this.filtresView) {
                for (const subFilter of filtreView.sub_filters) {
                    const type = subFilter.type.trim();
                    let method = 'taxonomy';
                    if(subFilter.method !== undefined) {
                      method = subFilter.method.trim();
                    }
                    
                    if (type === 'custom' && method === 'meta') {
                        for (let z = 0; z < subFilter.field.length; z++) {
                            const field_search = subFilter.field[z].trim();
                            let value_search = subFilter.value[z];

                            if (value_search === "true" || value_search === "false") {
                                value_search = Boolean(value_search);
                            }

                            if (offre.acf[field_search] === value_search) {
                                subFilter.count = (subFilter.count || 0) + 1;
                                break;
                            }
                        }
                    }

                    if (type === 'custom' && method === 'notempty') {
                        for (let z = 0; z < subFilter.field.length; z++) {
                            const field_search = subFilter.field[z].trim();

                            if (offre.acf[field_search] !== undefined && offre.acf[field_search] !== "") {
                                subFilter.count = (subFilter.count || 0) + 1;
                                break;
                            }
                        }
                    }

                    if (type === 'custom' && method === 'capacite') {
                        if(subFilter.capacite == undefined) {
                          subFilter.capacite = [];
                        }
                        
                        const field_search = subFilter.field.trim();
                        const propertyValue = offre.acf[field_search];

                        if (propertyValue !== undefined && propertyValue !== "" && !subFilter.capacite.includes(parseInt(propertyValue))) {
                            subFilter.capacite = [...subFilter.capacite, parseInt(propertyValue)];
                        }
                    }

                    if (type === 'custom' && method === 'taxonomy') {
                        const field_search = subFilter.taxonomy.trim();

                        if (offre.taxonomy[field_search] !== undefined &&
                            offre.taxonomy[field_search].some(i => subFilter.include.includes(i))) {
                            subFilter.count = (subFilter.count || 0) + 1;
                        }
                    }

                    if (type === 'custom' && method === 'post_type') {

                      if(subFilter.include.includes(offre.type)) {
                        subFilter.count = (subFilter.count || 0) + 1;
                      }

                    }
                }
            }
        }
    },
    resetFilterCounter() {
        for(let e=0; e<this.filtresView.length; e++) {
            if(this.filtresView[e].sub_filters.length > 0) {
                for(let f=0; f<this.filtresView[e].sub_filters.length; f++) {
                    this.filtresView[e].sub_filters[f].count = 0;
                }
            }
        }
    },
    activeGeoloc() {
      if(navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(this.GeolocSuccess, this.GeolocError);
      }
    },
    disableGeoloc() {
      this.$emit('geoLocSearch', false);
      this.$parent.geoloc = false;
      delete this.$parent.selectedFilters.geo;
    },
    GeolocSuccess(position) {
      this.$emit('geoLocSearch', position);
      this.$parent.geoloc = {lat: position.coords.latitude, lng:position.coords.longitude};
      this.$parent.selectedFilters['geo'] = [position.coords.latitude, position.coords.longitude];
    },
    GeolocError() {
      this.$emit('geoLocSearch', false);
      this.$parent.geoloc = false;
    },
  },
  mounted() {
    this.initFilters(this.$parent.globalfiltres);
  },
  watch: {
    offres: {
      handler() {
        this.updateFiltres(this.offres);
      },
      deep:true
    },
  }
}
</script>